import { getEventName } from "../../name-helpers/eventNameHelper"
import { FormattedMessage, injectIntl } from "react-intl"
import React from "react"
import { capitalize } from "../../name-helpers/nameFormatter"
import {Intl} from "../../state/helpers/IntlProps"

type Props = {
    intl: Intl
}

const SchedulingMenuMessage = (props: Props) => {
    const eventMenuName = getEventName(props.intl)
    const capitalizedEventName = capitalize(eventMenuName)
    return (
        <FormattedMessage
            id="main.menu.scheduling_page_label"
            defaultMessage="{eventName}s"
            values={{
                eventName: capitalizedEventName
            }}
        />
    )
}

export default injectIntl(SchedulingMenuMessage)


// WEBPACK FOOTER //
// ./src/common/layout/SchedulingMenuMessage.tsx